var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolAssemblyArea = function SvgFiremapSymbolAssemblyArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M9.749 14.041l.35.959h3.733l.36-.959h2.421l.351.959h1.9l-2.473-6h-1.832L12 15 9.526 9H7.695l-2.56 6h1.832l.36-.959zm-.47-1.3H7.822l.736-1.96zm6.864 0h-1.455l.736-1.96z",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapSymbolAssemblyArea;